import { PresentationalFilterFacet } from '../types';
import { getFilterPathParameters } from '../utils';

export default function useUpdatePath(
  setPath: (pathToSet: string, shouldScroll?: boolean) => void,
  pathname: string,
  isDevelopment: boolean
) {
  const updatePath = (
    path: string,
    filters: PresentationalFilterFacet[],
    params?: URLSearchParams,
    shouldScroll?: boolean
  ) => {
    const updatedFilterPathParameters = getFilterPathParameters(filters);

    const filterPathParameters = updatedFilterPathParameters
      ? `/${updatedFilterPathParameters}`
      : '';
    const stringParams = String(params ?? '');
    const queryParameters = stringParams ? `?${stringParams}` : '';
    const filterPrefix = isDevelopment ? '/filter' : '';

    // TODO: Check back for a better way to build the URL path
    const languagePrefix = ['/en', '/nl', '/fr'].find(prefix => pathname?.startsWith(prefix)) || '';
    const conditionalPath = `${languagePrefix}${filterPrefix}${path}${filterPathParameters}${queryParameters}`;
    setPath?.(conditionalPath, shouldScroll);
  };

  return { updatePath };
}
